// In ground with diving board, In ground without diving board, Above ground with diving board, Above ground without diving board
export const POOL_TYPES = [
  {
    label: 'In ground with diving board',
    value: 'In ground with diving board',
  },
  {
    label: 'In ground without diving board',
    value: 'In ground without diving board',
  },
  {
    label: 'Above ground with diving board',
    value: 'Above ground with diving board',
  },
  {
    label: 'Above ground without diving board',
    value: 'Above ground without diving board',
  },
];
